import axios from "axios";
import { action, observable, autorun, runInAction, makeObservable } from "mobx";
import appStore from "./appStore";

class GamingStore {
  userInfo = {
    name: "",
    mail: "",
    doc: "",
    area: "",
    charge: "",
  };
  errors = {};
  token = "";
  currentQuestion = null;
  currentAnswer = null;
  finish = false;
  ready = false;
  areas = [];
  charges = [];
  debug = 0;

  constructor() {
    makeObservable(this, {
      userInfo: observable,
      errors: observable,
      token: observable,
      currentQuestion: observable,
      currentAnswer: observable,
      finish: observable,
      ready: observable,
      areas: observable,
      charges: observable,
      debug: observable,
    });
  }

  setUserInfo(prop, value) {
    runInAction(() => (this.userInfo[prop] = value));
  }

  async register() {
    let fail = false;
    for (let key in this.userInfo) {
      if (key === 'charge')
		continue
      const val = this.userInfo[key];
      const check = !val || val === "";
      runInAction(() => (this.errors[key] = check));
      fail |= check;
    }
    if (fail) return;

    const splitedName = this.userInfo.name.split(" ");
    const nameLen = splitedName.length;
    const payload = {
      first_name: splitedName[0],
      last_name:
        nameLen > 1 ? [...splitedName].splice(1, nameLen).join(" ") : "",
      phone: "",
      area: this.userInfo.area,
      dni: this.userInfo.doc,
      email: this.userInfo.mail,
      //ocupation: this.userInfo.charge,
      ocupation: this.charges.length > 0 ? this.charges[0].id : undefined
    };
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/users`,
      payload
    );
    const { data } = response;
    const { token } = data;
    runInAction(() => (this.token = token));
    this.getCurrentQuestion();
    appStore.setPage("quiz");
  }

  @action
  async getCurrentQuestion() {
    this.ready = false;
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/users/question`,
      {
        headers: {
          token: this.token,
        },
      }
    );
    const { data } = response;
    const { question } = data;
    runInAction(() => {
      this.currentQuestion = question;
      if (!this.currentQuestion) {
        this.finish = true;
        appStore.setPage("thanks");
      }
      this.ready = true;
    });
  }

  @action
  async submitAnswer(question_id, answer_id) {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/questions/${question_id}`,
      {
        answer_id,
      },
      {
        headers: {
          token: this.token,
        },
      }
    );
    this.nextQuestion();
  }

  nextQuestion() {
    this.currentAnswer = undefined;
    this.getCurrentQuestion();
  }

  setCurrentAnswer(id) {
    runInAction(() => (this.currentAnswer = id));
  }

  @action
  async getCharges() {
    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/cargos/all`
    );
    const { data } = response;
    const { cargos } = data;
    runInAction(() => {
      this.charges = cargos;
      this.ready = true;
    });
  }

  @action
  async getAreas() {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/areas/all`
    );
    const { data } = response;
    const { areas } = data;
    runInAction(() => {
      this.areas = areas;
      this.ready = true;
    });
    appStore.setPage("login");
  }
}

const gamingStore = new GamingStore();
export default gamingStore;
autorun(() => {
  gamingStore.getAreas();
  gamingStore.getCharges();
});
